import type { UserProfile } from '~/types';
import classNames from 'classnames';
import {
  SheetContent,
  SheetDescription,
  SheetHeader,
  SheetTitle,
} from '../../components/ui/sheet';
import { EditExistingProfiles } from './ManageProfile/EditExistingProfiles';
import { AddNewProfiles } from './ManageProfile/AddNewProfiles';

interface Props {
  profiles: UserProfile[];
  userProfilesCanBeDeleted: boolean[];
  closeSheet: () => void;
}

export function ManageProfiles({
  profiles,
  userProfilesCanBeDeleted,
  closeSheet,
}: Props) {
  return (
    <div className="px-4">
      <SheetHeader>
        <SheetTitle>Manage Registrants</SheetTitle>
        {profiles.length > 0 ? (
          <SheetDescription>Manage or add new registrants.</SheetDescription>
        ) : (
          <SheetDescription>
            Select how many people to register.
          </SheetDescription>
        )}
      </SheetHeader>
      {profiles.length > 0 && (
        <section className="flex flex-col gap-2 pt-8">
          <EditExistingProfiles
            profiles={profiles}
            profilesCanBeDeleted={userProfilesCanBeDeleted}
          />
        </section>
      )}
      <section
        className={classNames({
          'pt-2': profiles.length === 0,
          'pt-8': profiles.length > 0,
        })}
      >
        <AddNewProfiles profiles={profiles} closeSheet={closeSheet} />
      </section>
    </div>
  );
}
